import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

const DISCLAIMER =
  'Not all customers find savings. Savings depend on state, policy features, coverage, driving history and other factors.';

/**
 * Disclaimer text
 */
export const DisclaimerText = styled(Typography).attrs((props) => ({
  ...props,
  children: DISCLAIMER,
}))`
  font-size: 12px;
  font-style: italic;
`;
